/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import cn from 'classnames';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import { mapValues } from 'lodash';

import {
  getDaysOfMonth,
  getMonths,
  getYearsInRange,
} from '../../../utils/handleDOB';
import SelectCustom from '../../SelectCustom';
import { PROFILE_FIELDS } from '../../../constants/strings';
import { IDS } from '../../../constants/ids';
import styles from './index.styl';

@injectIntl
@CSSModules(styles, { allowMultiple: true })
export default class DateDropdown extends Component {
  state = {
    month: '01',
    day: '01',
    year: '1980',
  };

  componentDidMount() {
    const { value } = this.props;

    if (value) {
      const parts = value.split('-');
      this.setState({ year: parts[0], month: parts[1], day: parts[2] });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { value } = this.props;
    if (nextProps.value !== value && nextProps.value === '') {
      this.setState(state => mapValues(state, () => null));
    }
    if (nextProps.value && nextProps.value !== value) {
      const parts = nextProps.value.split('-');
      this.setState({ year: parts[0], month: parts[1], day: parts[2] });
    }
  }

  getDate = () => {
    const { month, day, year } = this.state;
    const { onChange } = this.props;

    const updateValue = year && month && day ? `${year}-${month}-${day}` : null;
    onChange(updateValue);
  };

  handleSelect = (value, key) => {
    this.setState(
      {
        [key]: value ? value.value : value,
      },
      () => this.getDate(),
    );
  };

  render() {
    const { year, month, day } = this.state;
    const {
      intl: { formatMessage },
      required,
      className,
      disabled,
      endYear,
      labelMessageId,
    } = this.props;

    return (
      <div className={className}>
        <label styleName={cn('label', { required })}>
          {formatMessage(labelMessageId ? { id: labelMessageId } : PROFILE_FIELDS.fieldNames.dob)}
        </label>
        <div styleName="picker-wrapper">
          <SelectCustom
            id={IDS.FORM_FIELDS.DOB.MONTH}
            placeholder={formatMessage(PROFILE_FIELDS.fieldNames.month)}
            name="month"
            value={month}
            options={getMonths(year)}
            disabled={disabled}
            onChange={val => this.handleSelect(val, 'month')}
          />
          <SelectCustom
            id={IDS.FORM_FIELDS.DOB.DAY}
            disabled={!(year && month) || disabled}
            placeholder={formatMessage(PROFILE_FIELDS.fieldNames.day)}
            name="day"
            value={day}
            options={getDaysOfMonth(year, month)}
            onChange={val => this.handleSelect(val, 'day')}
          />
          <SelectCustom
            id={IDS.FORM_FIELDS.DOB.YEAR}
            placeholder={formatMessage(PROFILE_FIELDS.fieldNames.year)}
            name="year"
            value={year}
            options={getYearsInRange(1900, endYear)}
            disabled={disabled}
            onChange={val => this.handleSelect(val, 'year')}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DateDropdown/index.jsx